import React from 'react';
import cls from 'classnames';
import { MenuType } from '../../types/global';
import menuImg from '../../assets/menu-title.svg';
import folderImg from '../../assets/icon-folder.svg';

export interface MenuData {
  /**
   * 存储menu是否展开
   */
  [key: string]: boolean;
}

interface ArticleMenuPropType {
  menuList: MenuType[];
  onMenuClick: (data: string) => void;
  onUpdateMenu: () => void;
}

/**
 * 传出去的信息，用于上报埋点
 */
interface ArticleMenuStateType {
  menuExpand: MenuData;
  /**
   * img 中 src 的地址，写成变量的原因是考虑到请求失败后兜底
   */
  // imgURL: string;
}
const parseTreeJson: (treeNodes: MenuType[]) => MenuData = treeNodes => {
  if (!treeNodes || !treeNodes.length) {
    return {};
  }
  let menuExpand: MenuData = {};
  for (let i = 0, len = treeNodes.length; i < len; i++) {
    const treeNode = treeNodes[i];
    if (treeNode) {
      const childs = treeNode.children;
      if (childs) {
        menuExpand[treeNodes[i].id] = false;
      }

      if (childs && childs.length > 0) {
        const childMenu = parseTreeJson(childs);
        menuExpand = { ...menuExpand, ...childMenu };
      }
    }
  }
  return menuExpand;
};
export class ArticleMenu extends React.Component<
  ArticleMenuPropType,
  ArticleMenuStateType
> {
  state: ArticleMenuStateType = {
    menuExpand: { ...parseTreeJson(this.props.menuList), h0: true },
  };

  componentDidMount() {
    const { onUpdateMenu } = this.props;
    onUpdateMenu();
  }

  handleClickExpand: (id: string) => void = id => {
    const { menuExpand } = this.state;
    const { onUpdateMenu } = this.props;
    menuExpand[id] = !menuExpand[id];

    this.setState({ menuExpand }, () => {
      // css transition 有延迟动画，所以采用setTimeout确保更新菜单时已经重新渲染完成
      setTimeout(() => {
        onUpdateMenu();
      }, 400);
    });
  };

  renderMenu: (
    treeNode: MenuType[],
    isShow: boolean,
    // 主要用于border展示的判断
    noshowBorder?: boolean,
  ) => JSX.Element = (treeNode, isShow, noshowBorder = true) => {
    const { menuExpand } = this.state;
    const { onMenuClick } = this.props;
    const maxIndex = treeNode.length - 1;
    return (
      <ul>
        {treeNode.map((menu, index, array) => {
          return (
            <li
              className={cls('menu-item-block', { noShow: !isShow })}
              key={menu.id}>
              <div
                className={cls(`menu-item menu-item-${menu.level}`, {
                  // 不展示border:
                  // 1.目录列表的最后一项，即条件的第一个条件
                  // 2.目录item的下一项比这一项层级高，border长度与下一项长度对齐，不由此项展示border-bottom，而由下一项展示border-top
                  // 即条件的第二和第三个条件
                  noshowBorderBottom:
                    (noshowBorder &&
                      index === maxIndex &&
                      !menuExpand[menu.id]) ||
                    (isShow && index === maxIndex && !menuExpand[menu.id]) ||
                    (index < maxIndex &&
                      array[index].type > array[index + 1].type &&
                      !menuExpand[menu.id]),
                  // 情况1:h1-(h2-h1)
                  // 情况2:h1-(h3-h2)-h1
                  showBorderTop:
                    (index > 0 &&
                      array[index - 1].children &&
                      menuExpand[array[index - 1].id]) ||
                    (index > 0 && array[index - 1].type > array[index].type),
                })}>
                <a
                  href={`#${menu.id}`}
                  onClick={(event: React.MouseEvent) => {
                    event.preventDefault();
                    if (isShow) {
                      onMenuClick(menu.id);
                    }
                  }}>
                  {menu.text}
                </a>
                {menu.children && (
                  <div
                    className={cls('expand-icon', {
                      isExpand: menuExpand[menu.id],
                    })}
                    onClick={() => {
                      if (isShow) {
                        this.handleClickExpand(menu.id);
                      }
                    }}>
                    <img src={folderImg}></img>
                  </div>
                )}
              </div>
              {menu.children &&
                this.renderMenu(
                  menu.children,
                  menuExpand[menu.id],
                  noshowBorder && index === maxIndex && menuExpand[menu.id],
                )}
            </li>
          );
        })}
      </ul>
    );
  };

  render() {
    const { menuList } = this.props;
    const { menuExpand } = this.state;
    if (menuList.length > 1) {
      return (
        <div className="menu-list">
          <div
            className={cls('menu-list-body', {
              noExpand: !menuExpand.h0,
            })}>
            <div
              className={cls('menu-h0', {
                isExpand: menuExpand.h0,
              })}>
              <div className="menu-h0-left">
                <img src={menuImg} />
                <span>目次</span>
              </div>
              <div
                className={cls('menu-h0-right', {
                  isExpand: menuExpand.h0,
                })}
                onClick={() => {
                  this.handleClickExpand('h0');
                }}>
                <img src={folderImg} />
              </div>
            </div>
            {this.renderMenu(menuList, menuExpand.h0)}
          </div>
        </div>
      );
    } else {
      return <div className="menu-list"></div>;
    }
  }
}
